import { render } from "./CreateFooter.vue?vue&type=template&id=90450360&scoped=true"
import script from "./CreateFooter.vue?vue&type=script&lang=js"
export * from "./CreateFooter.vue?vue&type=script&lang=js"

import "./CreateFooter.vue?vue&type=style&index=0&id=90450360&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/movie-night/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90450360"]])

export default __exports__